import { getClassName } from 'src/Core/utility/jsx';
import styles from './infoPanel.module.scss';

const InfoPanel = ({ className, Header, children, sparse }) => {
  return (
    <div
      className={getClassName([
        styles.container,
        className,
        { [styles.sparse]: sparse },
      ])}
    >
      <Header />
      <div>{children}</div>
    </div>
  );
};

export default InfoPanel;
